export class CommandCounsellorGroupsService {
  constructor($resource, AuthService, ApiService, $cookies, CommandCounsellorsService) {
    "ngInject";

    this.$cookies = $cookies;
    this.$resource = $resource;
    this.apiService = ApiService;
    this.authService = AuthService;
    this.defaultGroupListFilters = {
      limit: null,
      pageId: null,
    };
   // this.commandCounsellorsService = CommandCounsellorsService;

    //End Points
    this.groupUrl = this.apiService.getResourceUrl("/tmGroup");
    this.getUnitIdentificationCodesUrl = this.apiService.getResourceUrl("/account/eligibleUnitIdentificationCode");
    this.groupWithIdUrl = this.apiService.getResourceUrl("/tmGroup/:group_id");
    this.getEligibleTransitionManagersUrl = this.apiService.getResourceUrl("/account/eligibleTransitionManagers/:unitIdentificationCode");
    this.tmGroupUrl = this.apiService.getResourceUrl("/tmGroup/transitionManager");
    this.tmGroupWithIdUrl = this.apiService.getResourceUrl("/tmGroup/transitionManager/:career_counselor_profile_id");

    
    //resources
    this.individualResource = this.$resource(this.groupUrl, null, {
      getDetails: { method: "get" },
      create: { method: "post" },
    });

    this.individualUnitIdentificationCodesResource = this.$resource(this.getUnitIdentificationCodesUrl, null, {
      getDetails: { method: "get" },
    });

    this.individualGroupResourceWithId = this.$resource(this.groupWithIdUrl, null,
      {
        getDetails: { method: "get" },
        update: { method: "put" },
        delete: { method: "delete" }
      }
    );

    this.individualEligibleTransitionManagersResource = this.$resource(this.getEligibleTransitionManagersUrl, null, {
      getDetails: { method: "get" },
    });

    this.individualTMGroupResource = this.$resource(this.tmGroupUrl, null, {
      getDetails: { method: "get" },
      create: { method: "post" },
      delete: { method: "delete" }
    });

    this.individualTMGroupWithIdResource = this.$resource(this.tmGroupWithIdUrl, null,
      {
        delete: { method: "delete" }
      }
    );

  }

  getAllGroups() {
    const promise = this.individualResource.getDetails().$promise;
    return promise
      .then(({ details }) => details.allTmGroups)
      .catch((error) => {
        // console.log("error", error);
        throw error
      });
  }

  getUnitIdentificationCodes() {
    const promise = this.individualUnitIdentificationCodesResource.getDetails().$promise;
    return promise
      .then(({ details }) => details.UnitIdentificationCode)
      .catch((error) => {
        throw error
      });
  }

  getGroupById(group_id) {
    const promise = this.individualGroupResourceWithId.getDetails({ group_id }).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        throw error
      });
  }

  updateGroup(details, type) {
    const _promise = type === "add" ? this.individualResource.create(details) : this.individualGroupResourceWithId.update(
      { group_id: details.groupId },
      {
        display_name: details.display_name,
        unitIdentificationCode: details.unitIdentificationCode
      }
    );
    const promise = _promise.$promise;
    return promise.then((response) => response);
  }

  getEligibleTransitionManagers(unitIdentificationCode) {
    const promise = this.individualEligibleTransitionManagersResource.getDetails({ unitIdentificationCode }).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        throw error
      });
  }

  addTMtoGroup(details) {
    const promise = this.individualTMGroupResource.create(this.setaddTMtoGroupObj(details)).$promise;
    return promise.then((response) => response).catch((error) => {
      throw error
    });
  }
  
  setaddTMtoGroupObj(details){
    const tmGroupObj = {
      transitionManagers:details.tmDetailsForGroup
    }
    return tmGroupObj;
  }

  deleteGroup(group_id) {
    const promise = this.individualGroupResourceWithId.delete({group_id}).$promise;
    return promise
      .then((response) => response)
      .catch((error) => {
        console.log("error", error);
      });
  }

  deleteTMFromGroup(career_counselor_profile_id) {
    const promise = this.individualTMGroupWithIdResource.delete({career_counselor_profile_id}).$promise;
    return promise
      .then((response) => response)
      .catch((error) => {
        console.log("error", error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-groups/command-counsellor-groups.service.js